import React, { useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import '../assets/css/home.css';
const HomeElysiumTower = () => {
    const [value, setValue] = useState(0);

    const images = [
        "/Elysium_Tower/home_images/00.jpg",
    ];
    useEffect(() => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    return (
        <div className="full-container home_image">
            <img src={`/Elysium_Tower/home_images/${String(value).padStart(2, "0")}.jpg`} alt="" className="home_page_images rotate_view" />
        </div>
    )
}

export default HomeElysiumTower;